import { Divider, useTheme } from '@mui/material';

import { CohortSummaryDetails } from '@verantos-dev/types-cohorts';

import CohortCharacteristicsTabularCategory from './CohortCharacteristicsTabularCategory';
import CohortCharacteristicsTabularRow from './CohortCharacteristicsTabularRow';
import { useCohortCharacteristicsTabularData } from '../hooks/useCohortCharacteristicsTabularData';

type CohortCharacteristicsTabularDataProps = {
  cohortSummaryData: CohortSummaryDetails;
};

const CohortCharacteristicsTabularData = ({
  cohortSummaryData,
}: CohortCharacteristicsTabularDataProps) => {
  const theme = useTheme();

  const rows = useCohortCharacteristicsTabularData(cohortSummaryData);

  return (
    <>
      {rows.map((row, index) => (
        <div key={row.id}>
          {row.category && <CohortCharacteristicsTabularCategory category={row.category} />}
          {!row.category && (
            <CohortCharacteristicsTabularRow name={row.name} value={row.value} index={index} />
          )}
          <Divider sx={{ borderColor: theme.palette.divider }} />
        </div>
      ))}
    </>
  );
};

export default CohortCharacteristicsTabularData;
